import { get, find } from 'lodash';
import React from 'react';
import moment from 'moment';
import { t } from '../../../../../modules/infra/i18n';

export default function getInputsConfig() {
  return {
    photoId: {
      accessor: 'photoId',
      title: t('customers:duplicates.customer_picture'),
      formatter: (_, entry) => (
        <div className="c-customer-avatar">
          <img alt="" src={get(entry, 'photoUrl')} />
        </div>
      ),
      onChange: (entry, duplicates) => {
        if (!entry.photoId) {
          entry.photoUrl = null;
          return entry;
        }

        const duplicate = find(duplicates, { photoId: entry.photoId });
        entry.photoUrl = duplicate.photoUrl;
      },
    },
    firstName: {
      accessor: 'firstName',
      title: t('customers:duplicates.first_name'),
    },
    lastName: {
      accessor: 'lastName',
      title: t('customers:duplicates.last_name'),
    },
    phone: {
      accessor: 'phone',
      title: t('customers:duplicates.phone_title'),
    },
    email: {
      accessor: 'email',
      title: t('customers:duplicates.email_header'),
    },
    birthDate: {
      accessor: 'birthDate',
      title: t('customers:duplicates.birthday'),
      formatter: value => (value ? moment(value).format('DD MMM YYYY') : t('customers:duplicates.not_set')),
    },
    unsubscribedCampaign: {
      accessor: 'unsubscribedCampaign',
      title: t('customers:duplicates.unsubscribed_campaigns'),
      formatter: value => (value ? t('customers:duplicates.yes') : t('customers:duplicates.no')),
    },
    blockNoShowFromBookNoPay: {
      accessor: 'blockNoShowFromBookNoPay',
      title: t('customers:duplicates.only_prepay'),
      formatter: value => (value ? t('customers:duplicates.yes') : t('customers:duplicates.no')),
    },
  };
}
